export enum SupportedLanguage {
  Bulgarian = 'bg',
  ChineseSimplified = 'zh-Hans-CN',
  ChineseTraditional = 'zh-Hant',
  Czech = 'cs',
  Danish = 'da',
  Dutch = 'nl-NL',
  English = 'en-US',
  Estonian = 'et',
  Finnish = 'fi',
  French = 'fr-FR',
  German = 'de-DE',
  Hungarian = 'hu',
  Icelandic = 'is',
  Indonesian = 'id',
  Italian = 'it-IT',
  Japanese = 'ja',
  Korean = 'ko',
  Lithuanian = 'lt',
  Norwegian = 'nb',
  Polish = 'pl',
  Portuguese = 'pt-PT',
  Romanian = 'ro-RO',
  Russian = 'ru-RU',
  Spanish = 'es-ES',
  Swedish = 'sv',
  Thai = 'th',
  Turkish = 'tr',
  Ukrainian = 'uk',
  Vietnamese = 'vi',
}
